import { IContactFormData } from 'src/SharedCustomHooks/UseContactFormData/types';
import {
  useContactAPIOperationsSuites
} from 'src/pages/SharedPageCustomHooks/UseContactSaveSuitesPage/useContactAPIOperationsSuitesPage';

interface UseContactFormSubmissionSuitesOptions {
  propertyId: string;
  suiteId: string;
  onSuccess?: () => void;
  onClose?: () => void;
}

interface UseContactFormSubmissionSuitesReturn {
  handleSubmitContactForm: (
    formData: IContactFormData,
    formType: string
  ) => Promise<void>;
  isLoading: boolean;
}

export const useContactFormSubmissionSuites = ({
  propertyId,
  suiteId,
  onSuccess,
  onClose,
}: UseContactFormSubmissionSuitesOptions): UseContactFormSubmissionSuitesReturn => {
  const {
    onCreateContact,
    onEditContact,
    isLoading,
    addExistingUserToSuite,
  } = useContactAPIOperationsSuites();
  
  const handleSubmitContactForm = async (
    formData: IContactFormData,
    formType: string
  ): Promise<void> => {
    try {
      let submissionSuccess: boolean;
      
      if (formType === 'Existing') {
        submissionSuccess = await addExistingUserToSuite(
          formData,
          propertyId,
          suiteId
        );
      } else if (formData.id) {
        // Editing an existing contact on the suites page.
        submissionSuccess = await onEditContact(formData, propertyId, suiteId);
      } else {
        // Creating 'new' contact on the suites page.
        submissionSuccess = await onCreateContact(formData, propertyId, suiteId);
      }
      
      if (submissionSuccess) {
        onSuccess?.();
        onClose?.();
      }
    } catch (error) {
      console.error('Contact form submission failed:', error);
    }
  };
  
  return {
    handleSubmitContactForm,
    isLoading,
  };
};